import React, { memo } from 'react'
import { MapMarker } from 'transfix-ui/components/MapMarker'
import { Box, makeStyles, Typography } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'
import { STOP_TYPE } from 'types/shipment'
import { formatAppointmentDate } from 'apps/fleet-planner/utils/marketplaceHelpers'
import { formatCityAndState } from 'apps/fleet-planner/utils/stops'

const useAppointmentStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  marker: {
    flex: `0 0 ${theme.spacing(1)}`,
  },
  container: {
    color: brandColors.coolGray6,
    minWidth: '0px',
  },
  text: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  textSecondaryColor: {
    color: brandColors.coolGray5,
  },
  textTertiaryColor: {
    color: brandColors.coolGray8,
  },
}))

interface IAppointmentProps {
  startAt: string
  endAt?: string | null
  timezone: string
  city?: string
  stateCode?: string
  mapMarkerType?: 'pickup' | 'delivery'
  textColor?: 'textSecondary' | 'textTertiary'
}

export const AppointmentMobile = memo<IAppointmentProps>(
  ({ city = '', endAt, mapMarkerType, startAt, stateCode = '', textColor = '', timezone }) => {
    const classes = useAppointmentStyles()
    const fullDate = formatAppointmentDate(startAt, endAt || '', timezone)
    const sequence = mapMarkerType === 'pickup' ? 0 : 1
    const colorText = () => {
      if (textColor === 'textSecondary') {
        return classes?.textSecondaryColor
      }

      if (textColor === 'textTertiary') {
        return classes?.textTertiaryColor
      }

      return ''
    }

    return (
      <div className={classes.root}>
        {mapMarkerType && (
          <div className={classes.marker}>
            <MapMarker type={mapMarkerType as STOP_TYPE} sequence={sequence} mini />
          </div>
        )}
        <Box className={classes.container}>
          <Typography className={colorText()} variant='button' component='div'>
            <div className={classes.text}>{formatCityAndState(city, stateCode)}</div>
          </Typography>
          <Typography className={colorText()} component='div' variant='body2'>
            <div className={classes.text}>{fullDate}</div>
          </Typography>
        </Box>
      </div>
    )
  }
)
